var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPrivateEntrance = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M13.5 30.5h14v-24h-14z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M20.396 18.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "m13.5 30.386 8.697-2.506V9.91L13.5 6.828"
}))));
export default SvgPrivateEntrance;